/* eslint-disable vue/html-closing-bracket-newline */
<template>
  <div>
    <LoginCard v-if="login" />
    <div v-else class="card" style="max-width: 700px; margin: auto">
      <div class="card-content">
        <p class="title">
          {{ $t("resetPassword") }}
        </p>

        <b-field :label="$t('password')" :message="$t('passwordInfo')">
          <b-input v-model="password" type="password" password-reveal />
        </b-field>
        <b-field :label="$t('repeatPassword')">
          <b-input v-model="password1" type="password" password-reveal />
        </b-field>
        <b-button :disabled="!valid" :loading="isLoading" type="is-primary" @click="resetPassword">
          {{ $t("confirm") }}
        </b-button>

        <form />
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";
import LoginCard from "@/components/LoginCard";

export default {
  name: "ResetPasswordCard",
  components: {
    LoginCard,
  },
  data() {
    return {
      isLoading: false,
      password: "",
      password1: "",
    };
  },
  computed: {
    login() {
      return this.$store.getters.getCurrentUser;
    },
    valid() {
      return this.password != "" && this.password1 != "";
    },
  },
  created() {},
  methods: {
    async resetPassword() {
      this.isLoading = true;
      if (this.password == this.password1) {
        try {
          await auth.confirmPasswordReset(this.$route.query.oobCode, this.password);
          this.$buefy.toast.open({
            duration: 3000,
            message: this.$t("passwordChanged"),
            type: "is-success",
          });
          this.$router.push({ name: "Login" });
        } catch (err) {
          this.$buefy.toast.open({
            duration: 3000,
            message: this.$t(err.code),
            type: "is-danger",
          });
        }
      } else {
        this.$buefy.toast.open({
          duration: 3000,
          message: this.$t("passwordNotMatching"),
          type: "is-danger",
        });
      }
      this.isLoading = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
